import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Spinner } from "./UI";

export default function ProtectedRoute({ children, requiredRole }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-50">
        <div className="flex flex-col items-center gap-4">
          <div className="text-5xl animate-bounce">🌱</div>
          <Spinner size={32} />
          <p className="text-brand-500 font-700">Loading AgriHealth...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRole === "premium" && user.role !== "premium" && user.role !== "admin") {
    return <Navigate to="/payments" state={{ upgrade: true }} replace />;
  }

  return children;
}
